module.exports = __webpack_public_path__ + "img/project-image.svg";